export const tutorialTypes = [
  'applab',
  'dance',
  '2018Minecraft',
  '2017Minecraft',
  'pre2017Minecraft',
  'other'
];
